var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeScreen === _vm.ScreensEnum.startConversation
    ? _c(
        "div",
        { staticClass: "container-fluid", attrs: { id: "start-chat-form" } },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", [
              _c("div", { staticClass: "panel" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "clearfix panel-heading branding-background branding-text chat-heading",
                  },
                  [
                    _c("h3", { staticClass: "panel-title pull-left" }, [
                      _vm._v("Start a Chat"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pull-right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "branding-text min-chat",
                          attrs: { href: "", title: "Minimize Chat" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.nextScreen(_vm.ScreensEnum.chatButton)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "glyphicon glyphicon-menu-down",
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.isUserNameChangedAndInvalid },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userName,
                            expression: "userName",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true },
                            expression: "{required: true}",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "name",
                          type: "text",
                          id: "userName",
                          maxlength:
                            "@VT.DataStore.Models.VisualTour.ChatSession.InitiateNameMaxLength",
                        },
                        domProps: { value: _vm.userName },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.startChat.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.userName = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.errors.first("name"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "has-error": _vm.isUserPhoneChangedAndInvalid },
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userPhone,
                            expression: "userPhone",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              regex:
                                /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/,
                            },
                            expression:
                              "{ required: true, regex: /^(1\\s?)?((\\([0-9]{3}\\))|[0-9]{3})[\\s\\-]?[\\0-9]{3}[\\s\\-]?[0-9]{4}$/ }",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "phone",
                          type: "text",
                          id: "userPhone",
                          required: "",
                          placeholder: "(999) 999-9999",
                          maxlength:
                            "@VT.DataStore.Models.VisualTour.ChatSession.InitiatePhoneNumberMaxLength",
                        },
                        domProps: { value: _vm.userPhone },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.startChat.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.userPhone = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.errors.first("phone"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-lg branding-background branding-text",
                      attrs: { id: "" },
                      on: { click: _vm.startChat },
                    },
                    [_vm._v("Start Chat")]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "userName" } }, [
      _vm._v("Name "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "userPhone" } }, [
      _vm._v("Phone (Text) "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }